import { createElementVNode as _createElementVNode, toDisplayString as _toDisplayString, createTextVNode as _createTextVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, createVNode as _createVNode, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, createBlock as _createBlock } from "vue"

const _hoisted_1 = /*#__PURE__*/_createElementVNode("i", { class: "mas mas-fill-1 ms-n1 me-1" }, "add", -1)

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_base_modal_button = _resolveComponent("base-modal-button")!
  const _component_alert_info = _resolveComponent("alert-info")!
  const _component_base_tab_link = _resolveComponent("base-tab-link")!
  const _component_LibContentBlocks = _resolveComponent("LibContentBlocks")!
  const _component_base_tab_pane = _resolveComponent("base-tab-pane")!
  const _component_base_tab = _resolveComponent("base-tab")!
  const _component_base_modal = _resolveComponent("base-modal")!

  return (_openBlock(), _createElementBlock(_Fragment, null, [
    _createVNode(_component_base_modal_button, {
      class: "btn btn-primary btn-icon",
      "modal-id": this.modalId
    }, {
      default: _withCtx(() => [
        _hoisted_1,
        _createTextVNode(" " + _toDisplayString(_ctx.$t('add')), 1)
      ]),
      _: 1
    }, 8, ["modal-id"]),
    _createVNode(_component_base_modal, {
      "modal-id": this.modalId,
      "dialog-classes": "modal-xl modal-dialog-scrollable",
      title: _ctx.$t('addBannerToSlot')
    }, {
      default: _withCtx(() => [
        _createVNode(_component_alert_info, {
          "can-use-html": "",
          description: _ctx.$t('descriptionBannerInSlotLibrary'),
          class: "mb-3"
        }, null, 8, ["description"]),
        _createVNode(_component_base_tab, { "tab-id": "nav-tab" }, {
          tabs: _withCtx(() => [
            (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(this.bannerLibraries, (bannerLibrary, i) => {
              return (_openBlock(), _createBlock(_component_base_tab_link, {
                key: bannerLibrary.library.code,
                target: bannerLibrary.library.code,
                title: bannerLibrary.library.description,
                "is-active": i === 0
              }, null, 8, ["target", "title", "is-active"]))
            }), 128))
          ]),
          content: _withCtx(() => [
            (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(this.bannerLibraries, (bannerLibrary, i) => {
              return (_openBlock(), _createBlock(_component_base_tab_pane, {
                key: bannerLibrary.library.code,
                id: bannerLibrary.library.code,
                "is-active": i === 0
              }, {
                default: _withCtx(() => [
                  _createVNode(_component_LibContentBlocks, {
                    "banner-slot-id": this.bannerSlotId,
                    "banner-lib-type": this.bannerLibType,
                    "cb-type": this.cbType,
                    library: bannerLibrary.library,
                    onCopied: _cache[0] || (_cache[0] = ($event: any) => (this.$emit('copied'))),
                    onExceptions: this.setExceptions
                  }, null, 8, ["banner-slot-id", "banner-lib-type", "cb-type", "library", "onExceptions"])
                ]),
                _: 2
              }, 1032, ["id", "is-active"]))
            }), 128))
          ]),
          _: 1
        })
      ]),
      _: 1
    }, 8, ["modal-id", "title"])
  ], 64))
}